import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import ModularCommentDisplay from 'components/Comment/ModularCommentDisplay';

export default function AutomatedCommentHistory({ ...props }) {
  const { text, createdDate, macrosRes, addMention } = props;
  return (
    // @ts-expect-error:  Expression is too complex
    <Flex flexDirection="column" gap="10px">
      <ModularCommentDisplay
        className="automatedComment"
        text={text}
        createdDate={createdDate}
        macrosRes={macrosRes}
        addMention={addMention}
        {...props}
      >
        <Box
          display="flex"
          padding="4px 4px 4px 12px"
          alignItems="center"
          alignSelf="stretch"
          justifyContent="space-between"
          gap="10px"
        >
          <Box display="flex">
            <Box marginRight="5px" whiteSpace="nowrap">
              <ModularCommentDisplay.HistoryFromName isColon />
            </Box>
            <Box>
              <ModularCommentDisplay.HistoryMessage />
            </Box>
          </Box>

          <Box display="flex" padding="4px" alignItems="center">
            <ModularCommentDisplay.CreatedAtHistory />
          </Box>
        </Box>
      </ModularCommentDisplay>
    </Flex>
  );
}
